import React, { useState, useEffect } from "react";
import { Table } from "react-bootstrap";
import './style.css';

const Covid = () => {

    const [data, setData] = useState([ ]);

    const covidData = async ()=> {
        const res = await fetch("https://api.covidtracking.com/v1/states/current.json");
        const actualData = await res.json();
        console.log(actualData);
        setData(actualData);
    }
    useEffect(() => {
        covidData();
    }, []);


    return (
        <>
            <h1>Covid-19 Reports</h1>
            <div className="container-fluid mt-5">
                <div className="main-heading">
                    <h1>WORLD</h1>
                </div>
                <div className="table-responsive">
                    <Table striped bordered>
                        <thead>
                            <tr>
                                <th>S No.</th>
                                <th>State</th>
                                <th>Confirmed</th>
                                <th>Recovered</th>
                                <th>Deaths</th>
                                <th>Hospitalized</th>
                                <th>Date Checked</th>
                                <th>Total</th>

                            </tr>
                        </thead>
                        <tbody>
                            {
                                data.map((d, i) => {
                                    return (
                                        <tr key={i+1}>
                                            <td>{d.i}</td>
                                            <td>{d.state}</td>
                                            <td>{d.positive}</td>
                                            <td>{d.recovered}</td>
                                            <td>{d.death}</td>
                                            <td>{d.hospitalized}</td>
                                            <td>{d.dateChecked}</td>
                                            <td>{d.total}</td>

                                        </tr>
                                    )
                                })
                            }
                        </tbody>
                    </Table>

                </div>

            </div>
        </>
    );
}

export default Covid;